import { StepperInput } from '../StepperInput';
import { jsx as _jsx } from "react/jsx-runtime";
export const PercentageStepper = props => {
  return /*#__PURE__*/_jsx(StepperInput, Object.assign({}, props, {
    formatStyle: "percentage"
  }));
};